import React, { forwardRef, useEffect, useState, } from 'react';
import classNames from 'classnames';
import { useSpring, animated } from '@react-spring/web';
const isWeb = true;
const Mask = (props, ref) => {
    const { prefix = 'cn-ui-m-', className, visible, view, ...others } = props;
    const [show, setShow] = useState(visible);
    let initOverflow = '';
    // notice: 如果mask 打开顺序为 AB， 关闭顺序也为 AB 会出问题
    if (isWeb) {
        initOverflow = document.body.style.overflow;
    }
    // @ts-ignore
    useEffect(() => {
        if (!visible && show) {
            const t1 = setTimeout(() => {
                setShow(false);
            }, 100);
            return () => {
                clearTimeout(t1);
            };
        }
        else {
            setShow(visible);
        }
        // disable page scroll in web
        if (isWeb) {
            if (visible) {
                document.body.style.overflow = 'hidden';
            }
            else {
                document.body.style.overflow = initOverflow;
            }
            return () => {
                const activeMasks = document.getElementsByClassName(`${clsPrefix}-mask--active`);
                if (activeMasks.length === 0) {
                    document.body.style.overflow = initOverflow;
                }
            };
        }
    }, [visible]);
    const { opacity } = useSpring({
        opacity: visible ? 1 : 0,
        config: {
            precision: 0.01,
            mass: 1,
            tension: 250,
            friction: 30,
            duration: 100,
            clamp: true,
        },
    });
    if (!show) {
        return null;
    }
    const clsPrefix = `${prefix}modal`;
    // Web
    return (React.createElement(animated.div, { ref: ref, ...others, 
        // disable-scroll
        // catchTouchMove
        className: classNames(className, `${clsPrefix}-mask`, {
            [`${clsPrefix}-mask--active`]: visible,
            [`${clsPrefix}-mask--inactive`]: !visible,
        }), style: {
            ...props.style,
            opacity,
            display: show ? undefined : 'none',
        } }));
};
Mask.displayName = 'Modal.Mask';
export default forwardRef(Mask);
